require('./bootstrap');

$(document).ready(function() {
    // CSRF Token for AJAX Calls
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': document.head.querySelector('meta[name="csrf-token"]').content
        }
    });

    // Dead Links
    $('[href="#"]').on('click', function(e) {
        e.preventDefault();
    });

    // Positive message timeout
    setTimeout(function() {
        $('.message.positive').animate({
            height: 'toggle',
            opacity: 'toggle'
        }, 500);
    }, 5000);

    // Overlay
    $('.overlay .close').on('click', function(e) {
        e.preventDefault();
        $('.overlaid').removeClass('overlaid');
        $(this).parents('.overlay').removeClass('active');
    });

    // Menus
    $('.hamburger').on('click', function(e) {
        e.preventDefault();
        $('.overlay').addClass('active');
        $('#site').addClass('overlaid');
    });

    $('.toggle-products').on('click', function(e) {
        e.preventDefault();
        $('#categories ul').toggleClass('active');
    });

    // Search
    $('#search').on('click', function(e) {
        e.preventDefault();
        $('.overlay').addClass('active');
        $('#site-search').addClass('overlaid').find('input').focus();
    });

    $('#site-search input, #site-search .close').on('keyup', function(event) {
        if (event.keyCode == 27) {
            $('.overlay.active').removeClass('active');
            $('#site-search').removeClass('overlaid');
        }
    });

    $('.search-again').on('click', function(e) {
        e.preventDefault();
        $('#search').trigger('click');
    });

    // Accordion
    $('.accordion dt').on('click', function() {
        $(this).toggleClass('active').next('dd').slideToggle();
    });

    if ($('.toggle .toggle-title').hasClass('active')) {
        $('.toggle .toggle-title.active').closest('.toggle').find('.toggle-inner').show();
    }

    $('.toggle .toggle-title').click(function() {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active').closest('.toggle').find('.toggle-inner').slideUp(200);
        } else {
            $(this).addClass('active').closest('.toggle').find('.toggle-inner').slideDown(200);
        }
    });

    // Sliders
    $('.slide-prev, .slide-next').on('click', function(e) {
        e.preventDefault();
    });

    $('.slider .slides').each(function() {
        $this = $(this);
        $this.slick({
            dots: true,
            appendDots: $this.parents('.slider'),
            autoplay: true,
            autoplaySpeed: 5000,
            prevArrow: $this.parents('.slider').find('.slide-prev'),
            nextArrow: $this.parents('.slider').find('.slide-next')
        });
    });

    $('#home .testimonials').slick({
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: true
    });

    $('#product-images').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        infinite: false,
        asNavFor: '#product-images-nav .product-slider',
        draggable: false
    });

    $('#product-images-nav .product-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '#product-images',
        focusOnSelect: true,
        infinite: false,
        vertical: true,
        centerMode: true,
        centerPadding: '5px',
        prevArrow: $('#product-images-nav .slide-prev'),
        nextArrow: $('#product-images-nav .slide-next'),
        responsive: [{
            breakpoint: 941,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                asNavFor: '#product-images',
                focusOnSelect: true,
                infinite: false,
                vertical: false,
                prevArrow: $('#product-images-nav .slide-prev'),
                nextArrow: $('#product-images-nav .slide-next')
            }
        }, {
            breakpoint: 769,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                asNavFor: '#product-images',
                focusOnSelect: true,
                infinite: false,
                vertical: true,
                centerMode: true,
                centerPadding: '5px',
                prevArrow: $('#product-images-nav .slide-prev'),
                nextArrow: $('#product-images-nav .slide-next')
            }
        }, {
            breakpoint: 569,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                asNavFor: '#product-images',
                focusOnSelect: true,
                infinite: false,
                vertical: false,
                prevArrow: $('#product-images-nav .slide-prev'),
                nextArrow: $('#product-images-nav .slide-next')
            }
        }]
    });

    $(document).on('click', '[data-lightbox]', function(e) {
        e.preventDefault();
        if ($(window).width() > 568) {
            $('.overlay').toggleClass('active');
            $('.lightbox').addClass('overlaid').attr('src', $(this).data('lightbox'));
        }
    });

    // Convert .svg image to SVG format (add class="svg")
    $('img.svg').each(function() {
        var $img = $(this);
        var imgID = $img.attr('id');
        var imgClass = $img.attr('class');
        var imgURL = $img.attr('src');

        $.get(imgURL, function(data) {
            // Get the SVG tag, ignore the rest
            var $svg = $(data).find('svg');

            // Add replaced image's ID to the new SVG
            if (typeof imgID !== 'undefined') {
                $svg = $svg.attr('id', imgID);
            }

            // Add replaced image's classes to the new SVG
            if (typeof imgClass !== 'undefined') {
                $svg = $svg.attr('class', imgClass + ' replaced-svg');
            }

            // Remove any invalid XML tags as per http://validator.w3.org
            $svg = $svg.removeAttr('xmlns:a');

            // Replace image with new SVG
            $img.replaceWith($svg);
        }, 'xml');
    });

    // Product
    $('#variants label').on('click', function() {
        price = $(this).data('price');
        price = toCurrency(price);
        $('#product-price .price').text('$' + price);
        variant = $(this).data('variant');
        $('[data-action="addtocart"]').data('variant', variant);
    });

    // Make it work for AJAX loaded elements
    $('.option.fileupload').each(function() {
        field = $(this);
        field.fileupload({
            formData: {
                name: field.prop('name'),
                field: field.data('id'),
                variant: field.data('variant')
            },
            dropZone: false,
            replaceFileInput: false,
            add: function(e, data) {
                field.siblings('.uploadblock').removeClass('hasimage').addClass('uploading');
                data.submit();
            },
            progress: function(e, data) {
                progress = parseInt(data.loaded / data.total * 100, 10) + '%';
                progressbar = field.parent().siblings('span.progress').children('i'); // ADD THIS TO THE VIEW
                progressbar.css('width', progress);
            },
            done: function(e, data) {
                result = data.result;
                if (! result.status) {
                } else if (result.status === 201) {
                    file = result.response;
                    field.siblings('.uploadblock').show();
                    field.siblings('.uploadblock').find('.uploaded-image').attr('src', file.response);
                    field.val('');
                } else if (result.status === 500) {
                    field.siblings('.uploadblock').removeClass('uploading').addClass('error');
                }
            }
        });
    });

    $(window).resize(function() {
        manageHomeSlides();
        offsetTabContent();
        resizeInstagram();
    }).resize();

    $('.tabs dt a').on('click', function(e) {
        e.preventDefault();

        if ($(window).width() > 568) {
            $('.tabs dt').removeClass('active');
            $(this).parents('dt').addClass('active');
        } else {
            $(this).parents('.tabs').find('dd').slideUp();
            $(this).parents('dt').next('dd').slideDown();
        }
    });

    // Cart
    var hidecart;

    $(document).on('click', '[data-action="addtocart"]', function(e) {
        e.preventDefault();
        clearTimeout(hidecart);

        trigger = $(this);
        trigger.addClass('loading');
        qty = $('#product_qty').val();
        variant = $(this).data('variant');
        price = $('.price')[0].innerHTML.substring(1);
        studio_reference = $('#studio_reference').val();
        comments = $('#comments').val();
        values = [];
        upload_fields = [];

        $('.option:visible').each(function() {
            values.push({
                id: $(this).data('id'),
                value: $(this).val()
            });
        });

        $('.upload_field').each(function() {
            upload_fields.push($(this).val());
        });

        $.post('/cart', {
            qty: qty,
            variant_id: variant,
            values: values,
            price: price,
            upload_fields: upload_fields,
            studio_reference: studio_reference,
            comments: comments
        }).done(function(item) {
            toggleCart();

            lineID = item.data.id;
            var lineIDs = [];
            var lineCount = 0;

            $.each($('#cart-items li'), function() {
                lineIDs.push($(this).attr('id'));
                lineCount++;
            });

            inlist = lineIDs.indexOf('line' + lineID);

            setTimeout(function() {
                if (inlist != -1) {
                    cartline = $('#line' + lineID);
                    newqty = item.data.quantity;

                    $('#quantity-' + lineID + ' span').text(newqty);
                } else {
                    cartlist = $('#cart-div #cart-items');

                    if (item.data.image.length) {
                        productimg = item.data.image;
                    } else {
                        productimg = '/img/product-fallback.png';
                    }

                    var productDetails = '';
                    for (var property in item.data.details) {
                        productDetails += '<dt>' + item.data.details[property].label + ':</dt><dd>' + (item.data.details[property] === null ? "" : item.data.details[property].value) + '</dd>';
                    }
                    cartitemtemplate = $('#tmpl-cart-item').html()
                                        .replace(/{lineID}/g, item.data.id)
                                        .replace(/{productID}/g, item.data.variant.product.id)
                                        .replace(/{productURL}/g, item.data.variant.slug)
                                        .replace(/{productImg}/g, productimg)
                                        .replace(/{productTitle}/g, item.data.variant.product.name)
                                        .replace(/{productVariantName}/g, item.data.variant.name)
                                        .replace(/{productDetails}/g, productDetails)
                                        .replace(/{productPrice}/g, item.data.price)
                                        .replace(/{productQty}/g, item.data.quantity);
                    $('#cart-items, #cart-footer').addClass('active');
                    $('.empty').removeClass('active');
                    $('#cart-items').append(cartitemtemplate);
                }

                updateCartSummary();

                hidecart = setTimeout(function() {
                    hideCart();
                }, 3000);
            }, 300);
        }).fail(function(error) {
            $([document.documentElement, document.body]).animate({
                scrollTop: $('#message').offset().top
            }, 500);
            $('.message').addClass('negative').html(error.responseJSON.error);
            setTimeout(function() {
                $('.message').animate({
                    queue: false,
                    height: 0,
                    opacity: 0
                }, 400, function() {
                    $('.message').removeClass('negative').html('').removeAttr('style');
                });
            }, 2500);
        }).always(function() {
            trigger.removeClass('loading');
        }, 'json');
    });

    $(document).on('click', '[data-action="removefromcart"]', function(e) {
        e.preventDefault();
        clearTimeout(hidecart);

        trigger = $(this);
        trigger.addClass('loading');
        lineID = $(this).data('line');
        cartline = $('#line' + lineID);

        $.ajax({
            url: '/line-items/' + lineID,
            type: 'DELETE'
        }).done(function(item) {
            cartline.addClass('removing');
            setTimeout(function() {
                cartline.remove();
                updateCartSummary();
                if (! $('#cart-items li:not(.empty)').length > 0) {
                    $('#cart-items').removeClass('active');
                    $('.empty').addClass('active');
                }
                if ($('#line' + lineID + '-main').length > 0)
                    $('#line' + lineID + '-main').remove();
            }, 250);
        }).fail(function(error) {
            // console.log(error);
        }).always(function() {
            trigger.removeClass('loading');
        }, 'json');
    });

    $(document).on('click', '[data-action="createtemplate"]', function(e) {
        e.preventDefault();

        $('#preview-placeholder').empty().append('<img src="/img/loading.gif" />').addClass('overlaid').addClass('loading');
        var variant_id = $(this).data('variant');
        $('.overlay').addClass('active');
        $.post('/create-template', {
            variant: variant_id
        }).done(function (response) {
            $('#preview-placeholder').removeClass('loading').empty().append(response);
        });
    });

    $(document).on('click', '[data-action="savetemplate"]', function(e) {
        e.preventDefault();

        $('.overlay .close').click();

        name = $("#template_name").val();
        variant_id = $(this).data('variant');
        reference = $('#studio_reference').val();
        comments = $('#comments').val();
        quantity = $('#product_qty').val();
        fields = [];

        $(document).find('.option:visible').each(function() {
            fields.push({
                id: $(this).data('id'),
                value: $(this).val(),
                parent: $(this).data('parent-id')
            });
        });

        $.post('/template', {
            name: name,
            quantity: quantity,
            variant_id: variant_id,
            fields: fields,
            reference: reference,
            comments: comments
        }).done(function(response) {
            $([document.documentElement, document.body]).animate({
                scrollTop: $('#message').offset().top
            }, 500);
            $('.message').addClass('positive').html(response.message);
            setTimeout(function() {
                $('.message').animate({
                    queue: false,
                    height: 0,
                    opacity: 0
                }, 400, function() {
                    $('.message').removeClass('positive').html('').removeAttr('style');
                });
            }, 2500);
        }).fail(function(error) {
            $([document.documentElement, document.body]).animate({
                scrollTop: $('#message').offset().top
            }, 500);
            $('.message').addClass('negative').html(error.responseJSON.error);
            setTimeout(function() {
                $('.message').animate({
                    queue: false,
                    height: 0,
                    opacity: 0
                }, 400, function() {
                    $('.message').removeClass('negative').html('').removeAttr('style');
                });
            }, 2500);
        });
    });

    $(document).on('click', '[data-action="updatetemplate"]', function(e) {
        e.preventDefault();

        var template_id = $(this).data('template');
        fields = [];
        $('.option').each(function() {
            fields.push({ id: $(this).data('id'), value: $(this).val(), parent: $(this).data('parent-id') });
        });
        reference = $('#studio_reference').val();
        comments = $('#comments').val();
        quantity = $('#product_qty').val();

        $.post('/update-template', {
            quantity: quantity,
            template_id: template_id,
            fields: fields,
            reference: reference,
            comments: comments
        }).done(function(response) {
            $([document.documentElement, document.body]).animate({
                scrollTop: $('#message').offset().top
            }, 500);
            $('.message').addClass('positive').html(response.message);
            setTimeout(function() {
                $('.message').animate({
                    queue: false,
                    height: 0,
                    opacity: 0
                }, 400, function() {
                    $('.message').removeClass('positive').html('').removeAttr('style');
                });
            }, 2500);
        }).fail(function(error) {
            $([document.documentElement, document.body]).animate({
                scrollTop: $('#message').offset().top
            }, 500);
            $('.message').addClass('negative').html(error.responseJSON.error);
            setTimeout(function() {
                $('.message').animate({
                    queue: false,
                    height: 0,
                    opacity: 0
                }, 400, function() {
                    $('.message').removeClass('negative').html('').removeAttr('style');
                });
            }, 2500);
        });
    });

    $(document).on('change', '.optiongroup input, .optiongroup select, .optional-features select', function() {
        $this = $(this);
        $group = $this.parents('.optiongroup');
        $id = $this.data('id');
        $val = $this.val();
        $addToCart = $this.parents('.product-options').find('.addtocart');

        removeChildren($id);
        $('.parent-' + $id).remove();

        if ($val != '') {
            $this.addClass('selected');
            $group.addClass('loading');
            $addToCart.prop('disabled', true);

            $.ajax({
                'type': 'POST',
                'url': '/get-fields',
                'data': {
                    'id': $id,
                    'value': $val
                }
            }).done(function(response) {
                $.each(response, function(i, value) {
                    if (i == 0) {
                        $group.after(value).next().addClass('parent-' + $id).find('.option').attr('data-parent-id', $id);
                    } else {
                        $('.parent-' + $id).last().after(value).next().addClass('parent-' + $id).find('.option').attr('data-parent-id', $id);
                    }

                    if (value.indexOf('optional') > -1) {
                        var $optGroup = $('.parent-' + $id).last();
                        var $label = $optGroup.find('label').html();
                        var $targetId = $optGroup.find('select').attr('data-id');

                        if ($('.optional-features:visible').length < 1)
                            $('.optional-features').css('display', 'block');

                        $('.optional-features').append('<a href="#option-' + $targetId + '" data-field="' + $targetId + '" class="optional-feature parent-' + $id + '">' + $label + '</a>');
                    }
                });

                $addToCart.prop('disabled', false);
                $group.removeClass('loading');
            });
        }
        updatePrice();
    });

    // Coupon on Checkout page
    $(document).on('click', '[data-action="apply-coupon"]', function(e) {
        e.preventDefault();

        $.post('/coupon', {
            coupon: $('#coupon-code').val()
        }).done(function(item) {
            if (item.status == '200') {
                $('.order-subtotal').text('$' + item.total);
                $('.coupon-item').show();
                $('.coupon-item-hide').hide();
                $('.coupon-label').text('Coupon - ' + item.coupon_code);
                $('#cart-coupon').text('- $' + item.discount);
                $('#cart-total').text('$' + item.total);
                $('.coupon-message').text(item.message);
                $('.coupon-success').show();
                $('.coupon-fail').hide();
            }

            if (item.status == '422') {
                $('.coupon-message').text(item.message);
                $('.coupon-success').hide();
                $('.coupon-fail').show();
            }
        }).fail(function(error) {
            // console.log(error);
        }).always(function() {
            // console.log(always);
        }, 'json');
    });

    $(document).on('click', '.decrease-qty, .increase-qty', function () {
        updateQty($(this));
    });

    $(document).on('change', '.button-increments-input', function () {
        updateQty($(this));
    });

    $('.button-increments-input').trigger('change');

    $('[href="#logout"]').on('click', function(e) {
        e.preventDefault();
        $('#logout').submit();
    });

    $('[href="#account"]').on('click', function(e) {
        e.preventDefault();
        $(this).parent('li').toggleClass('active');
    });

    $('#icon-cart').on('click', function(e) {
        e.preventDefault();
        toggleCart();
    });

    $('.hide-cart').on('click', function(e) {
        e.preventDefault();
        toggleCart();
    });

    $(document).on('click', '.view-swatches', function(e) {
        e.preventDefault();

        $('#preview-placeholder').empty().append('<img src="/img/loading.gif" />').addClass('overlaid').addClass('loading');
        $tar = $(this).data('target');
        $('.overlay').addClass('active');
        $.post('/preview-swatches', {
            field: $tar
        }).done(function(response) {
            $('#preview-placeholder').removeClass('loading').empty().append(response);
        });
    });

    $(document).on('click', '.swatch', function(e) {
        e.preventDefault();
        $fieldID = $(this).data('field-id');
        $optionID = $(this).data('option-id');

        $('#option-' + $fieldID).val($optionID).trigger('change');
        $(this).parents('.swatches').removeClass('overlaid');
        $('.overlay').removeClass('active');
    });

    // Optional Features
    $(document).on('click', '.optional-feature', function(e) {
        e.preventDefault();
        $(this).hide();
        $tar = $(this).attr('href');
        $($tar).trigger('change').parents('.optiongroup').removeClass('optional').insertBefore('.optional-features');
        if ($('.optional-features').find(':visible').length < 1) {
            $('.optional-features').hide();
        }
    });

    $(document).on('click', '.remove-asset', function(e) {
        e.preventDefault();
        var id = $(this).data('id');

        $.ajax({
            url: '/product/delete-image/' + id,
            type: 'DELETE'
        }).done(function(response) {
            $('#asset-' + id).remove();
        }, 'json');
    });

    $(document).on('click', '.fav', function (e) {
        e.preventDefault();
        var variant = $(this).data("variant");
        var element = $(this);

        $.post('/favourites', {
            variant_id: variant
        }).done(function (response) {
            $([document.documentElement, document.body]).animate({
                scrollTop: $('#message').offset().top
            }, 500);
            $('.message').addClass('positive').html(response.message);
            setTimeout(function () {
                $('.message').animate({
                    queue: false,
                    height: 0,
                    opacity: 0
                }, 400, function () {
                    $('.message').removeClass('positive').html('').removeAttr('style');
                });
            }, 2500);

            if(response.add) {
                element.addClass("active");
            }
            else if (!response.add) {
                element.removeClass("active");
            }
        });
    });

    $(document).on('click', '.delete-favourite', function (e) {
        e.preventDefault();
        var variant_id = $(this).data("variant-id");
        $.post('/favourites', {
            variant_id: variant_id
        }).done(function (response) {
            $('.tr').filter('[data-variant-id="' + variant_id + '"]').remove();
        });
    });

    $(document).on('click', '.deletetemplate', function(e) {
        e.preventDefault();
        var template_id = $(this).data("template-id");
        $.post('/delete-template', {
            template_id: template_id
        }).done(function (response) {
            $('.tr').filter('[data-template-id="' + template_id + '"]').remove();
        });
    });

    // Colour Swatches
    $('#colour-swatches .gallery-title').on('click', function() {
        $(this).toggleClass('active').next('.swatches-container').slideToggle();
    });
});

function manageHomeSlides() {
    var $bodyW = $('body').outerWidth();
    var $newH = $bodyW <= 768 ? ($bodyW / 2.15) : ($bodyW / 2.15);

    $('#home .slideimage').height($newH).each(function() {
        $src = $(this).data($bodyW <= 768 ? 'mobile' : 'full');
        $(this).css('background-image', 'url(' + $src + ')');
    });
}

function offsetTabContent() {
    if ($(window).width() > 568) {
        $('.tabs dd').each(function(e) {
            $offset = 0;
            $('.tabs dt').each(function() {
                $offset = $(this).outerHeight() > $offset ? $(this).outerHeight() : $offset;
            });
            $(this).css('margin-top', $offset - 1);
        });
    } else {
        $('.tabs dd').css('margin-top', 0);
    }
}

function resizeInstagram() {
    $('#instagram-feed li:not(.handle) a').each(function() {
        $(this).outerHeight($(this).outerWidth());
    });
}

function updateQty($this, $key = null, $shift = null) {
    let $parent = $this.closest('.button-increments'),
        $decrease = $parent.find('.decrease-qty'),
        $increase = $parent.find('.increase-qty'),
        $input = $parent.find('input'),
        $increment = parseFloat($input.attr('increment')),
        $min = parseFloat($input.attr('min')),
        $max = parseFloat($input.attr('max')),
        $val = parseFloat($input.val());

    if ($this.hasClass('decrease-qty')) {
        $val = $val - $increment;
    }

    if ($this.hasClass('increase-qty')) {
        $val = $val + $increment;
    }

    if ($val > $max) {
        $val = $max;
    }

    if ($val < $min) {
        $val = $min;
    }

    $input.val($val);

    $decrease.toggleClass('inactive', $val <= $min);
    $increase.toggleClass('inactive', $val >= $max);

    updatePrice();
}

function updatePrice() {
    $options = [{
        id   : 'quantity',
        value: $('#product_qty').val()
    }];

    $('.option').each(function() {
        $options.push({
            id   : $(this).data('id'),
            value: $(this).val()
        });
    });

    $.ajax({
        'type': 'POST',
        'url' : '/calculate-price',
        'data': {
            'options': $options,
            'variant': $('#variant_id').val()
        }
    }).done(function(response) {
        $('.price').html(response.price.AUD);
        $('.converted').html(response.price.converted);
    });
}

function removeChildren($id) {
    $cid = $('.parent-' + $id).find('[data-id]').data('id');
    if ($cid) {
        $('.parent-' + $cid).remove();
        removeChildren($cid);
    }
}

function thisURL(params) {
    var url, thisURL = document.location.pathname;

    if (params === 1) {
        // option = 1 = full page name with all parameters eg: products.php?id_product=1
        thisURLwithParam = thisURL.substring(0, (thisURL.indexOf('#') == -1) ? thisURL.length : thisURL.indexOf('#'));
        thisURLwithParam = thisURLwithParam.substring(0, getPosition(thisURL, '/', 2));
        url = thisURLwithParam;
    } else {
        // option = null = just the page name (eg: products.php)
        thisURL = thisURL.substring(0, (thisURL.indexOf('#') == -1) ? thisURL.length : thisURL.indexOf('#'));
        thisURL = thisURL.substring(0, (thisURL.indexOf('?') == -1) ? thisURL.length : thisURL.indexOf('?'));
        thisURL = thisURL.substring(0, getPosition(thisURL, '/', 2));
        url = thisURL;
    }

    if (url == '/') {
        url = '/home';
    }

    return url;
}

function thisSubURL(params) {
    var url, thisSubURL = document.location.pathname;

    if (params === 1) {
        // option = 1 = full page name with all parameters eg: products.php?id_product=1
        thisURLwithParam = thisSubURL.substring(0, (thisSubURL.indexOf('#') == -1) ? thisSubURL.length : thisSubURL.indexOf('#'));
        thisURLwithParam = thisURLwithParam.substring(0, getPosition(thisSubURL, '/', 3));
        url = thisURLwithParam;
    } else {
        // option = null = just the page name (eg: products.php)
        thisSubURL = thisSubURL.substring(0, (thisSubURL.indexOf('#') == -1) ? thisSubURL.length : thisSubURL.indexOf('#'));
        thisSubURL = thisSubURL.substring(0, (thisSubURL.indexOf('?') == -1) ? thisSubURL.length : thisSubURL.indexOf('?'));
        thisSubURL = thisSubURL.substring(0, getPosition(thisSubURL, '/', 3));
        url = thisSubURL;
    }

    if (url == '/') {
        url = '/home';
    }

    return url;
}

function getPosition(string, subString, index) {
   return string.split(subString, index).join(subString).length;
}

function toggleCart() {
    cart = $('#cart-div');
    cartLink = $('li.cart > a');
    overlay = $('.cart-overlay');

    if (cart.hasClass('active')) {
        cart.removeClass('active');
        cartLink.removeClass('active');
        overlay.removeClass('active');
    } else {
        cart.addClass('active');
        cartLink.addClass('active');
        overlay.addClass('active');
    }
}

function hideCart() {
    $('#icon-cart').removeClass('active');
    $('li.cart > a').removeClass('active');
    $('.cart-overlay').removeClass('active');
}

function updateCartSummary() {
    var itemcount = 0;
    var itemtotal = 0;

    $('#cart-items li:not(.empty)').each(function() {
        var quantity = $(this).find('.quantity');
        quantity = quantity[0].innerHTML;
        price = $(this).find('.product-price').text().replace('$', '');
        itemcount += parseInt(quantity, 10);
        itemtotal += parseFloat(price);
    });

    $('.summary-count strong').text(itemcount);
    $('.summary-total').text('$' + itemtotal.toFixed(2));
}

function toCurrency(price) {
    return parseFloat(price, 10).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}

function fromCurrency(value) {
    return value.replace(/[^0-9\.]+/g, '');
}



// WEBPACK FOOTER //
// ./resources/assets/js/app.js